import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "../data/business";

export default function MobileCTA() {
    return (
        <div
            data-testid="mobile-cta-bar"
            className="fixed bottom-0 left-0 right-0 z-[60] border-t border-line bg-paper/95 p-3 backdrop-blur-md sm:hidden"
        >
            <a
                href={WHATSAPP_URL}
                data-testid="mobile-cta-whatsapp"
                className="flex items-center justify-center gap-2 bg-ink px-6 py-3.5 font-mono text-[11px] uppercase tracking-[0.2em] text-paper"
            >
                <MessageCircle size={15} />
                Agendar pelo WhatsApp
            </a>
        </div>
    );
}
